import React from 'react';
import { View } from 'react-native';
import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import SearchDropdownSelector from './SearchDropdownSelector';
import { GET_CONTACTS } from '../../../common/graphql/person';

// Name as the row title, contact details and clients as secondary lines.
const PersonSelectorItem = ({ item }) => {
	const styles = useThemedStyles(createStyles);
	const contactDetails = [item.email, item.phoneNumber, item.role].filter(Boolean).join(' - ');
	const attachedClientNames = (item.attachedClients || []).map(client => client.name).filter(Boolean);
	const clientsLabel = `Clients: ${attachedClientNames.length ? attachedClientNames.join(', ') : 'none'}`;

	return (
		<View style={styles.item}>
			<Text style={styles.title}>{item.name}</Text>
			{Boolean(contactDetails) && <Text style={styles.detail}>{contactDetails}</Text>}
			<Text style={styles.detail}>{clientsLabel}</Text>
		</View>
	);
};

const renderPersonItem = item => <PersonSelectorItem item={item} />;

const PersonSelector = (props) => {

	const { query } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_CONTACTS}
			renderItem={renderPersonItem}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select person"
			{...props}
		/>
	);
};

const createStyles = ({ ui: { colors, type } }) => ({
	item: {
		gap: 2,
	},
	title: {
		...type.rowTitle,
		color: colors.text,
	},
	detail: {
		...type.secondary,
		color: colors.textSecondary,
	},
});

export default PersonSelector;
